import React from "react";
import { ZODIAC_SIGNS } from "../../Data";
import styles from "./LogoNavBar.module.scss";
import Image from "next/image";
import { zodiacDataType } from "../../Enum";
import { usePathname, useRouter } from "next/navigation";

interface navBarProps {
  activeLogo: zodiacDataType;
  setActiveLogo: React.Dispatch<React.SetStateAction<zodiacDataType>>;
}

const LogoNavBar = ({ activeLogo, setActiveLogo }: navBarProps) => {
  const router = useRouter();
  const pathname = usePathname();
  const handleActiveIndex = (data: zodiacDataType) => {
    if (activeLogo?.value === data?.value) return;
    setActiveLogo(data);
    router.push(
      `${pathname?.replace(`/${activeLogo?.value}`, "")}/${data.value}`
    );
  };
  return (
    <div>
      <ul className={styles.navLogoContainer}>
        {ZODIAC_SIGNS.map((element) => {
          return (
            <li
              className={`${styles.navElement} ${
                activeLogo?.name === element.name ? styles.activeNavElement : ""
              }`}
              key={element.name}
            >
              <div
                className={styles.logoWrapper}
                onClick={() => handleActiveIndex(element)}
              >
                <Image
                  src={element.logo}
                  alt="zodiac-logo"
                  height={39}
                  width={39}
                />
              </div>
              <span
                className={
                  activeLogo?.logo === element.name
                    ? `${styles.activeText}`
                    : ``
                }
              >
                {element.name}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default LogoNavBar;
